import {
  completePollinatorGardenInvestigation,
  discoverPollinatorGarden,
  getRelationshipInvestigationSnapshot,
  isPollinatorGardenRouteAvailable,
  persistRelationshipInvestigationSnapshot,
} from '../DiscoveryLabState.js';
import { RelationshipInvestigation } from '../minigames/relationship/RelationshipInvestigation.js';
import { POLLINATOR_GARDEN_PRODUCTION_READY } from './PollinatorGardenAssets.js';
import { POLLINATOR_GARDEN_INVESTIGATION } from './PollinatorGardenConfig.js';

/**
 * Progression adapter for the eventual production-art presentation. Calling it
 * while the art gate is closed cannot discover, start, reward, or restore the
 * garden.
 */
export function enterPollinatorGardenInvestigation() {
  if (!POLLINATOR_GARDEN_PRODUCTION_READY || !isPollinatorGardenRouteAvailable()) {
    return { available: false as const, reason: 'production-art-gated' as const };
  }

  const discovery = discoverPollinatorGarden();
  if (!discovery.unlocked) {
    return { available: false as const, reason: 'route-unavailable' as const };
  }
  const savedSnapshot = getRelationshipInvestigationSnapshot(
    POLLINATOR_GARDEN_INVESTIGATION.id,
  );
  const investigation = new RelationshipInvestigation(
    POLLINATOR_GARDEN_INVESTIGATION,
    {
      onStateChanged: snapshot => { persistRelationshipInvestigationSnapshot(snapshot); },
      onCompleted: (_result, _config, snapshot) => {
        completePollinatorGardenInvestigation(snapshot);
      },
    },
    savedSnapshot,
  );
  persistRelationshipInvestigationSnapshot(investigation.getSnapshot());
  return {
    available: true as const,
    newlyDiscovered: discovery.newlyDiscovered,
    investigation,
  };
}
